import { FormControl, MenuItem, MenuProps, Select } from '@mui/material';
import React from 'react';
import { DeviceModeState } from '@redux/person/personTypes';
import { Text } from 'components/Typography';
import { makeCustomSelectStyles } from '../../customStyles';
import styles from './TriggerSelectBlock.scss';

export enum TriggerTypes {
  inBed = 'IN_BED',
  nearBed = 'IN_BEDROOM',
  inBedroom = 'BED_BEDROOM',
  enteringBedroom = 'ENTERING_BEDROOM',
  enteringBed = 'ENTERING_BED',
  existingBed = 'EXITING_BED'
}

export const BedroomTriggerTypes = [
  TriggerTypes.inBed,
  TriggerTypes.nearBed,
  TriggerTypes.inBedroom,
  TriggerTypes.enteringBedroom,
  TriggerTypes.enteringBed,
  TriggerTypes.existingBed
];

export const LivingSpaceTriggerTypes = [TriggerTypes.inBedroom];

export const TriggerSelectOptions: Record<TriggerTypes, string> = {
  [TriggerTypes.inBed]: 'In the bed',
  [TriggerTypes.nearBed]: 'In bedroom not in bed',
  [TriggerTypes.inBedroom]: 'In the room',
  [TriggerTypes.enteringBedroom]: 'Entering the room',
  [TriggerTypes.enteringBed]: 'Entering bed',
  [TriggerTypes.existingBed]: 'Exiting bed'
};

export const TriggerPreviewOptions: Record<TriggerTypes, string> = {
  [TriggerTypes.inBed]: 'In bed',
  [TriggerTypes.nearBed]: 'In bedroom not in bed',
  [TriggerTypes.inBedroom]: 'In the room',
  [TriggerTypes.enteringBedroom]: 'Entering the room',
  [TriggerTypes.enteringBed]: 'Entering bed',
  [TriggerTypes.existingBed]: 'Exiting bed'
};

type TriggerSelectProps = {
  trigger: TriggerTypes;
  onTriggerChanged: (value: TriggerTypes) => void;
  deviceMode?: DeviceModeState;
  error?: string;
};

export const TriggerSelectBlock: React.FC<TriggerSelectProps> = ({ trigger, onTriggerChanged, deviceMode, error }) => {
  const customSelectStyles = makeCustomSelectStyles();
  const menuProps: Partial<MenuProps> = {
    autoFocus: false,
    classes: { paper: customSelectStyles.menuPaperLong },
    anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
    transformOrigin: { vertical: 'top', horizontal: 'left' }
  };

  const triggerOptions = deviceMode === DeviceModeState.LIVING_SPACE ? LivingSpaceTriggerTypes : BedroomTriggerTypes;

  return (
    <div className={styles.container}>
      <Text variant="nlg">Trigger</Text>
      <FormControl fullWidth>
        <Select
          MenuProps={menuProps}
          value={trigger}
          onChange={(event) => {
            if (!event.target.value) return;
            onTriggerChanged(event.target.value as TriggerTypes);
          }}
          className={customSelectStyles.select}
        >
          {triggerOptions.map((option) => (
            <MenuItem value={option} key={option}>
              <Text variant="md">{TriggerSelectOptions[option]}</Text>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {error && (
        <Text variant="sm" className={styles.error}>
          {error}
        </Text>
      )}
    </div>
  );
};
